import Env from "../environments";
import { APP_USER_KEY } from "../global/constants";
import { ROOT_GLOBAL } from "../global/root";
import { LocalStorage } from "../models/LocalStorage";
import { callEvent, EVENTS } from "./event";
import { devLog } from "./log"
import { genULID } from "./slug";

const MESSAGE = {
  OPEN_SETTING: "openSetting",
  SHOW_APP_INFO: "openAppInfo",
  OPEN_AVAILABLE_STORE: "openAvailableStore",
  OPEN_SITE: "openSite",
  OPEN_DIRECT_CHECKOUT: "openDirectCheckout",
  OPEN_USERS: "openUsers",
  OPEN_ROUTE: "openRoute",
  OPEN_PAGE: "openPage",
  LOAD_ORDER: "loadOrder",
  CHECKOUT: "checkout",
  TRACK_ORDER: "trackOrder",
  ADD_TO_CART: "addToCart",
  FAST_CHECKOUT: "fastCheckout",
  POP: "pop",
  RESET: "reset",
  SET_LOADING: "setLoading",
  SET_PRODUCT: "setProduct",
  SET_ADD_STATUS: "setAddStatus",
  SET_CART_STATUS: "setCartStatus",
  SET_STORES_STATUS: "setStoresStatus",
  SET_USERS_STATUS: "setUsersStatus",
  SET_HOME_STATUS: "setHomeStatus",
  SET_FAST_CHECKOUT_STATUS: "setFastCheckoutStatus",
  SET_TRACK_ORDER_STATUS: "setTrackOrderStatus",
  SET_CHECKOUT_PRICE: "setCheckoutPrice",
  SET_PRICE_LOADING: "setPriceLoading",
  BACK_HOME: "backHome",
  BACK: "back",
  GET_STORAGE: "getStorage",
  SET_STORAGE: "setStorage",
  REMOVE_STORAGE: "removeStorage",
  EXIST_STORAGE: "existStorage",
  SET_LANGUAGE: "setLanguage",
  SET_SHIPPING_COUNTRY: "setShippingCountry",
  SET_BILLING_COUNTRY: "setBillingCountry",
  SET_CURRENCY: "setCurrency",
  SET_SHOW_NAVIGATION_BAR: "setShowNavigationBar",
  LOGIN: "login",
  LOGOUT: "logout",
  RELOAD_APP: "reloadApp",
  RELOAD_DATA: "reloadData",
  RELOAD: "reload",
  CHANGE_SETTING: "changeSetting",
  SCROLL_TOP: "scrollTop",
  SHARE: "share",
  REQUEST_CAMERA_PERMISSION: "requestCameraPermission",
  GET_CAMERA_PERMISSION_STATUS: "getCameraPermissionStatus",
  OPEN_OS_APP_SETTING: "openOSAppSetting",
  RELOAD_HOMEPAGE: "reloadHomePage",
  RELOAD_HEAD_LESS: "reloadHeadLess",
  POP_NEXT: "popNext",
  RESUMED: "resumed",
  OPEN_PAYMENT_URL: "openPaymentUrl",
  HANDLE_DEEP_LINK: "handleDeepLink",
  OPEN_EXTERNAL_LINK: "openExternalLink",
  OPEN_NOTIFICATION: "openNotification",
  SET_COOKIE: "setCookie",
  GET_COOKIE: "getCookie",
  UPDATE_BADGE_COUNT: "updateBadgeCount",
  REMOVE_BADGE: "removeBadge",
  GET_HOST: "getHost",
  REQUEST_NOTIFICATION_PERMISSION: "requestNotificationPermission",
  GET_NOTIFICATION_PERMISSION_STATUS: "getNotificationPermissionStatus",
  LOG_EVENT_GA: "logEventGA",
  LOG_VIEW_ITEM_GA: "logViewItemGA",
  LOG_ADD_TO_CART_GA: "logAddToCartGA",
  LOG_BEGIN_CHECKOUT_GA: "logBeginCheckoutGA",
  LOG_PURCHASE_GA: "logPurchaseGA",
  LOG_EVENT_FA: "logEventFA",
  LOG_VIEW_ITEM_FA: "logViewItemFA",
  LOG_ADD_TO_CART_FA: "logAddToCartFA",
  LOG_BEGIN_CHECKOUT_FA: "logBeginCheckoutFA",
  LOG_PURCHASE_FA: "logPurchaseFA",
};

const NAVIGATION_ICON_STATUS = {
  HIDE: 0,
  DISABLE: 1,
  SHOW: 2,
  ACTIVE: 3,
}

export const MINI_APP = {
  MESSAGE: MESSAGE,
  NAVIGATION_ICON_STATUS: NAVIGATION_ICON_STATUS,
  language: "",
  shippingCountry: "",
  billingCountry: "",
  currency: "",
  isLoggedIn: false,
  postMessage: miniAppPostMessage,
  getReturnData: getReturnData,
  openSite: ({ url, ar = {}, replace = false, popUlti = "" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_SITE,
      data: url,
      url: url,
      arguments: ar,
      popUlti: popUlti,
      replace: replace,
    });
  },
  openSetting: () => {
    miniAppPostMessage({ message: MESSAGE.OPEN_SETTING });
  },
  openDirectCheckout: ({ url, ar = {}, replace = false, popUlti = "" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_DIRECT_CHECKOUT,
      data: url,
      url: url,
      arguments: ar,
      popUlti: popUlti,
      replace: replace,
    });
  },
  openAppInfo: () => {
    miniAppPostMessage({ message: MESSAGE.SHOW_APP_INFO });
  },
  openAvailableStore: ({ ar = {}, replace = false, popUlti = "" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_AVAILABLE_STORE,
      arguments: ar,
      popUlti: popUlti,
      replace: replace,
    });
  },
  openRoute: ({ url, ar = null, replace = false, popUlti = "" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_ROUTE,
      name: url,
      url: url,
      arguments: ar,
      popUlti: popUlti,
      replace: replace,
    });
  },
  openPage: ({ url = "", ar = {}, replace = false, popUlti = "" } = {}) => {
    let uri = new URL(url);
    if (uri.pathname.indexOf(ROOT_GLOBAL.SHORT) === 0) {
      MINI_APP.handleDeepLink({
        url: url,
      });
      return;
    }
    miniAppPostMessage({
      message: MESSAGE.OPEN_PAGE,
      url: url,
      arguments: {
        url: url,
        routeName: uri.pathname === ROOT_GLOBAL.HOME_PAGE ? ROOT_GLOBAL.HOME_PAGE : uri.pathname.replace(/\/$/, ""),
        ...ar,
      },
      popUlti: popUlti,
      replace: replace,
    });
  },
  openUsers: ({ ar = {}, replace = false, popUlti = "" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_USERS,
      arguments: ar,
      popUlti: popUlti,
      replace: replace,
    });
  },
  backHome: () => {
    miniAppPostMessage({
      message: MESSAGE.BACK_HOME,
    });
  },
  back: () => {
    miniAppPostMessage({
      message: MESSAGE.BACK,
    });
  },
  pop: (data) => {
    miniAppPostMessage({
      message: MESSAGE.POP,
      data: data,
    });
  },
  reset: () => {
    miniAppPostMessage({
      message: MESSAGE.RESET,
    });
  },
  loadOrder: () => {
    miniAppPostMessage({
      message: MESSAGE.LOAD_ORDER,
    });
  },
  checkout: ({ ar = {}, replace = false, popUlti = "" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.CHECKOUT,
      arguments: ar,
      replace: replace,
      popUlti: popUlti,
    });
  },
  trackOrder: () => {
    miniAppPostMessage({
      message: MESSAGE.TRACK_ORDER,
    });
  },
  addToCart: (product) => {
    miniAppPostMessage({
      message: MESSAGE.ADD_TO_CART,
      data: product,
    });
  },
  fastCheckout: (product) => {
    miniAppPostMessage({
      message: MESSAGE.FAST_CHECKOUT,
      data: product,
    });
  },
  setLoading: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_LOADING,
      data: status,
    });
  },
  setProduct: (product) => {
    miniAppPostMessage({
      message: MESSAGE.SET_PRODUCT,
      data: product,
    });
  },
  setAddStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_ADD_STATUS,
      data: status,
    });
  },
  setCartStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_CART_STATUS,
      data: status,
    });
  },
  setStoresStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_STORES_STATUS,
      data: status,
    });
  },
  setUsersStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_USERS_STATUS,
      data: status,
    });
  },
  setHomeStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_HOME_STATUS,
      data: status,
    });
  },
  setFastCheckoutStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_FAST_CHECKOUT_STATUS,
      data: status,
    });
  },
  setTrackOrderStatus: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_TRACK_ORDER_STATUS,
      data: status,
    });
  },
  setCheckoutPrice: (value) => {
    miniAppPostMessage({
      message: MESSAGE.SET_CHECKOUT_PRICE,
      data: value,
    });
  },
  setPriceLoading: (status) => {
    miniAppPostMessage({
      message: MESSAGE.SET_PRICE_LOADING,
      data: status,
    });
  },
  getStorage: (keys) => getReturnData(MESSAGE.GET_STORAGE, {
    data: keys,
  }),
  setStorage: (data = {}) => getReturnData(MESSAGE.SET_STORAGE, {
    data: data,
  }),
  removeStorage: (keys) => getReturnData(MESSAGE.REMOVE_STORAGE, {
    data: keys,
  }),
  existStorage: (key) => getReturnData(MESSAGE.EXIST_STORAGE, {
    data: key,
  }),
  setLanguage: (value) => {
    miniAppPostMessage({
      message: MESSAGE.SET_LANGUAGE,
      data: value,
    });
  },
  setShippingCountry: (value) => {
    miniAppPostMessage({
      message: MESSAGE.SET_SHIPPING_COUNTRY,
      data: value,
    });
  },
  setBillingCountry: (value) => {
    miniAppPostMessage({
      message: MESSAGE.SET_BILLING_COUNTRY,
      data: value,
    });
  },
  setCurrency: (value) => {
    miniAppPostMessage({
      message: MESSAGE.SET_CURRENCY,
      data: value,
    });
  },
  logout: () => {
    miniAppPostMessage({
      message: MESSAGE.LOGOUT,
    });
  },
  login: () => {
    miniAppPostMessage({
      message: MESSAGE.LOGIN,
    });
  },
  openPaymentUrl: ({ url } = {}) => getReturnData(MESSAGE.OPEN_PAYMENT_URL, {
    url: url,
    data: url,
  }),
  setShowNavigationBar: (value) => {
    miniAppPostMessage({
      message: MESSAGE.SET_SHOW_NAVIGATION_BAR,
      data: value,
    });
  },
  share: ({ url, subject } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.SHARE,
      data: url,
      url: url,
      subject: subject,
    });
  },
  handleDeepLink: ({ url, allowExternal = false, setCookie = true } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.HANDLE_DEEP_LINK,
      url,
      allowExternal,
      setCookie,
    });
  },
  openExternalLink: ({ url, mode = "externalApplication" } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_EXTERNAL_LINK,
      url,
      mode,
    });
  },
  openNotification: ({ data, reOpen = true } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.OPEN_NOTIFICATION,
      data,
      reOpen,
    });
  },
  setCookie: ({ name, value, expiresDate, maxAge, isSecure, isHttpOnly, sameSite, deleteWhenEmpty } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.SET_COOKIE,
      name,
      value,
      expiresDate,
      maxAge,
      isSecure,
      isHttpOnly,
      sameSite,
      deleteWhenEmpty,
    });
  },
  getCookie: (key) => getReturnData(MESSAGE.GET_COOKIE, {
    key: key,
  }),
  updateBadgeCount: (value) => {
    miniAppPostMessage({
      message: MESSAGE.UPDATE_BADGE_COUNT,
      data: value,
    });
  },
  removeBadge: () => {
    miniAppPostMessage({
      message: MESSAGE.REMOVE_BADGE,
    });
  },
  getHost: () => getReturnData(MESSAGE.GET_HOST),
  requestNotificationPermission: () => getReturnData(MESSAGE.REQUEST_NOTIFICATION_PERMISSION),
  getNotificationPermissionStatus: () => getReturnData(MESSAGE.GET_NOTIFICATION_PERMISSION_STATUS),
  requestCameraPermission: () => getReturnData(MESSAGE.REQUEST_CAMERA_PERMISSION),
  getCameraPermissionStatus: () => getReturnData(MESSAGE.GET_CAMERA_PERMISSION_STATUS),
  openOSAppSetting: () => {
    miniAppPostMessage({ message: MESSAGE.OPEN_OS_APP_SETTING });
  },
  reloadHomePage: () => {
    miniAppPostMessage({ message: MESSAGE.RELOAD_HOMEPAGE });
  },
  reloadHeadLess: () => {
    miniAppPostMessage({ message: MESSAGE.RELOAD_HEAD_LESS });
  },
  reloadApp: () => {
    miniAppPostMessage({ message: MESSAGE.RELOAD_APP });
  },
  onBack: miniAppOnBack,
  onChangeLanguage: miniAppOnChangeLanguage,
  onReloadData: miniAppReloadData,
  onScrollTop: scrollTop,
  onReload: miniAppReload,
  onChangeSetting: miniAppChangeSetting,
  onPopNext: onPopNext,
  onResumed: onResumed,
  onLogout: onLogout,
  logEventGA: ({ name, parameters, global } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_EVENT_GA,
      name: name,
      parameters: parameters,
      global: global
    });
  },
  logViewItemGA: ({ value, items, parameters, currency, source, global } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_VIEW_ITEM_GA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      source: source,
      global: global,
    });
  },
  logAddToCartGA: ({ value, items, parameters, currency, orderCode, source, global } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_ADD_TO_CART_GA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      orderCode: orderCode,
      source: source,
      global: global,
    });
  },
  logBeginCheckoutGA: ({ value, items, parameters, currency, orderCode, coupon, global } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_BEGIN_CHECKOUT_GA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      orderCode: orderCode,
      coupon: coupon,
      global: global,
    });
  },
  logPurchaseGA: ({ value, items, parameters, currency, orderCode, coupon, tax, shipping, transactionId, affiliation, global } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_PURCHASE_GA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      orderCode: orderCode,
      coupon: coupon,
      tax: tax,
      shipping: shipping,
      transactionId: transactionId,
      affiliation: affiliation,
      global: global,
    });
  },
  logEventFA: ({ name, valueToSum, parameters } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_EVENT_FA,
      name: name,
      parameters: parameters,
      valueToSum: valueToSum,
    });
  },
  logViewItemFA: ({ type, value, currency, parameters, items, sku, source } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_VIEW_ITEM_FA,
      type: type,
      value: value,
      currency: currency,
      parameters: parameters,
      items: items,
      sku: sku,
      source: source,
    });
  },
  logAddToCartFA: ({ value, items, parameters, currency, orderCode, source } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_ADD_TO_CART_FA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      orderCode: orderCode,
      source: source,
    });
  },
  logBeginCheckoutFA: ({ value, items, parameters, currency, orderCode, coupon } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_BEGIN_CHECKOUT_FA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      orderCode: orderCode,
      coupon: coupon,
    });
  },
  logPurchaseFA: ({ value, items, parameters, currency, orderCode, coupon } = {}) => {
    miniAppPostMessage({
      message: MESSAGE.LOG_PURCHASE_FA,
      value: value,
      items: items,
      parameters: parameters,
      currency: currency,
      orderCode: orderCode,
      coupon: coupon,
    });
  },
}

if (+Env.DUTY_CAST_EXTENSION_DEBUG_MODE) {
  window.MINI_APP = MINI_APP;
}

export function scrollTop() {
  $('html, body').animate({
    scrollTop: 0
  }, 1000);
}

export function getReturnData(type, params = {}) {
  const jobId = genULID();
  const result = new Promise((resolve, reject) => {
    const cb = (e) => {
      resolve(e?.detail);
      document.removeEventListener(jobId, cb);
    }
    document.addEventListener(jobId, cb);
  });
  miniAppPostMessage({
    jobId: jobId,
    message: type,
    ...params,
  });
  return result;
};

export function miniAppPostMessage(message) {
  if (window?.DCMessage?.postMessage) {
    window.DCMessage.postMessage(JSON.stringify(message));
    return;
  }

  if (window?.flutter_inappwebview?.callHandler) {
    window.flutter_inappwebview.callHandler('DCMessage', JSON.stringify(message));
    return;
  }

  devLog("MINI_APP postMessage", message);
};

export function miniAppOnBack() {
  if ($(".search-box.focus").length) {
    $(".search-box", this.element).removeClass("focus");
    setTimeout(() => {
      $("#search_input", this.element).blur();
    }, 0);
    return;
  }
  MINI_APP.back();
}

export function miniAppOnChangeLanguage(lang) {
  LocalStorage.setLanguage(lang);
  document.dispatchEvent(
    new CustomEvent(EVENTS.MINI_APP_CHANGE_LANGUAGE, { detail: lang })
  );
}

export function miniAppReloadData() {

}

export function miniAppReload() {
  window.location.reload();
}

export function miniAppChangeSetting() {
  if (MINI_APP.language !== LocalStorage.getLanguage()) {
    callEvent(EVENTS.MINI_APP_CHANGE_LANGUAGE, LocalStorage.getLanguage());
  }
  if (MINI_APP.isLoggedIn !== LocalStorage.isLoggedIn()) {
    callEvent(EVENTS.CHANGE_AUTH_STATUS, LocalStorage.isLoggedIn());
  }
  if (MINI_APP.shippingCountry !== LocalStorage.getShipping()) {
    callEvent(EVENTS.MINI_APP_CHANGE_SHIPPING_COUNTRY, LocalStorage.getShipping());
  }
  if (MINI_APP.currency !== LocalStorage.getCurrency()) {
    callEvent(EVENTS.MINI_APP_CHANGE_CURRENCY, LocalStorage.getCurrency());
  }
  MINI_APP.language = LocalStorage?.getLanguage();
  MINI_APP.shippingCountry = LocalStorage?.getShipping();
  MINI_APP.billingCountry = LocalStorage?.getBilling();
  MINI_APP.currency = LocalStorage?.getCurrency();
  MINI_APP.isLoggedIn = LocalStorage?.isLoggedIn();
}

export function onPopNext() {

}

export function onResumed() {

}

export function onLogout() {
  LocalStorage.setLoginInfo();
  callEvent(EVENTS.CHANGE_AUTH_STATUS, false);
}

export async function setAppToken(token) {
  const user = ((await MINI_APP.getStorage(APP_USER_KEY)) ?? {})[APP_USER_KEY] ?? {};
  user.token = token;
  await MINI_APP.setStorage({
    [APP_USER_KEY]: user
  });
}

window.DCReceivedMesage = ({ message, data }) => {
  switch (message) {
    case MESSAGE.BACK:
      MINI_APP.onBack();
      break;
    case MESSAGE.SET_LANGUAGE:
      MINI_APP.onChangeLanguage(data);
      break;
    case MESSAGE.RELOAD_DATA:
      MINI_APP.onReloadData();
      break;
    case MESSAGE.SCROLL_TOP:
      MINI_APP.onScrollTop();
      break;
    case MESSAGE.RELOAD:
      MINI_APP.onReload();
      break;
    case MESSAGE.CHANGE_SETTING:
      MINI_APP.onChangeSetting();
      break;
    case MESSAGE.POP_NEXT:
      MINI_APP.onPopNext();
      break;
    case MESSAGE.RESUMED:
      MINI_APP.onResumed();
      break;
    case MESSAGE.LOGOUT:
      MINI_APP.onLogout();
      break;
    default:
      break;
  }
}